<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>In-Out Buffer Time Master</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>From Date</b></p>

            <input id="datePickerId" type="date" v-model="fromdate" />
            <!-- <input id="datePickerId" type="date" v-model="fromdate" /> -->
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>To Date</b></p>
            <input id="datePickerId" type="date" v-model="todate" />
          </v-col>
        </v-row>
        <br />
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><b>Late In Buffer Time</b></p>
            <input type="number" v-model="intime" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Early Out Buffer Time</b></p>
            <input type="number" v-model="outtime" outlined />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><b>Half Day In Buffer Time</b></p>
            <input type="number" v-model="half_intime" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Half Day Out Buffer Time</b></p>
            <input type="number" v-model="half_outtime" outlined />
          </v-col>
        </v-row>
        <br />
        <v-row justify="center" dense v-if="fromdate && todate">
          <v-btn color="warning" @click="save()">Save</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="inoutbuffertimemaster_list.length > 0">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>In-Out Buffer Time List</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />
        <v-data-table :headers="headers" :items="inoutbuffertimemaster_list" class="mytable">
          <!-- <template v-slot:top> -->

          <!-- </template> -->
          <template v-slot:item.action="{ item }">
            <div>
              <v-avatar size="25" class="edit-avatar" @click="editItem(item)">
                <v-icon class="mr-2 edit-v-icon" title="edit">edit</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-avatar size="35">
                <v-icon class="mr-4 v-icon-size" color="red" @click="deleteInOutTime(item)">mdi-trash-can</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-data-table>
        <v-dialog v-model="dialog_edit" max-width="900px">
          <v-card>
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>Edit In-Out Buffer Time Master</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-col cols="12" sm="12" md="12">
              <v-card class="box" v-if="buffer_details_data != null">
                <!-- {{buffer_details_data}} -->
                <v-row justify="center" dense>
                  <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <p><b>Late In Buffer Time</b></p>
                    <input type="number" v-model="buffer_details_data.inbuffertime" outlined />
                  </v-col>
                  <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <p><b>Late Out Buffer Time</b></p>
                    <input type="number" v-model="buffer_details_data.outbuffertime" outlined />
                  </v-col>
                  <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <p><b>Half Day In Buffer Time</b></p>
                    <input type="number" v-model="buffer_details_data.latebuffertime" outlined />
                  </v-col>
                  <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <p><b>Half Day Out Buffer Time</b></p>
                    <input type="number" v-model="buffer_details_data.earlybuffertime" outlined />
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <input id="datePickerId" type="date" v-model="buffer_details_data.fromdate_edit" />
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <input id="datePickerId" type="date" v-model="buffer_details_data.todate_edit" />
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-checkbox class="pt-1 mt-1" v-model="buffer_details_data.isactive" color="success"
                      label="Isactive?"></v-checkbox>
                  </v-col>
                </v-row>
              </v-card>
              <v-row justify="center">
                <v-btn class="button" @click="dialog_edit = false">Cancel</v-btn>
                <v-btn class="button" @click="editbufferDeatils()">Save</v-btn>
              </v-row>
            </v-col>
          </v-card>
        </v-dialog>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    overlay: false,
    dialog_edit: false,
    headers: [
      { text: "Sr No", value: "count" },
      { text: "From Date", value: "fromdate" },
      { text: "To Date", value: "todate" },
      { text: "Late In Buffer Time", value: "inbuffertime" },
      { text: "Early Out Buffer Time", value: "outbuffertime" },
      { text: "Half Day In Buffer Time", value: "latebuffertime" },
      { text: "Half Day Out Buffer Time", value: "earlybuffertime" },
      { text: "Status", value: "isactive", class: "my-header-style" },
      { text: "Actions", value: "action", class: "my-header-style" },
      { text: "Delete", value: "delete" },
    ],
    inoutbuffertimemaster_list: [],
    fromdate: new Date().toISOString().slice(0, 10),
    // todate: new Date().toISOString().slice(0, 10),
    todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),
    intime: "",
    half_intime: "",
    outtime: "",
    half_outtime: "",
    buffer_details_data: [],
  }),
  methods: {
    editItem(item) {
      this.buffer_details_data = item;
      this.dialog_edit = true;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    editbufferDeatils() {
      const data = {
        buffer_details_data: this.buffer_details_data,
      };
      axios
        .post("/EmployeeBiometric/editbufferDeatils", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar(
              "#4caf50",
              "In-out buffer master edited Successfully"
            );
            this.onLoad();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
          this.dialog_edit = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.buffer_details_data = [];
        });
    },
    onLoad() {
      axios
        .post("EmployeeBiometric/inOutTimeMasterHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inoutbuffertimemaster_list =
              res.data.inoutbuffertimemaster_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    deleteInOutTime(item) {
      if (!confirm("Are You Sure You Want To Delete...?")) return;
      const data = {
        inoutbuffertimeid: item.id,
      };
      this.overlay = true;
      axios
        .post("/EmployeeBiometric/deleteInoutbuffertimemaster", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inoutbuffertimemaster_list =
              res.data.inoutbuffertimemaster_list;
            this.showSnackbar("green", "Deleted Successfully...");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    save() {
      const data = {
        fromdate: this.fromdate,
        todate: this.todate,
        half_intime: this.half_intime,
        half_outtime: this.half_outtime,
        intime: this.intime,
        outtime: this.outtime,
      };
      this.overlay = true;
      axios
        .post("/EmployeeBiometric/saveInoutbuffertimemaster", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inoutbuffertimemaster_list =
              res.data.inoutbuffertimemaster_list;
            this.showSnackbar("green", "Saved Successfully...");
            //  this.show_fees = true
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
input[type="date"] {
  width: 100%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
input[type="number"] {
  width: 100%;
  display: inline-block;
  border: 1px solid gray;
  border-radius: 4px;
  box-sizing: border-box;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
